
import type { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const UsedCarPurchasePage = lazy(() => import('../pages/services/used-car-purchase/page'));
const AccidentCarPurchasePage = lazy(() => import('../pages/services/accident-car-purchase/page'));
const CarExportPage = lazy(() => import('../pages/services/car-export/page'));
const TruckPurchasePage = lazy(() => import('../pages/services/truck-purchase/page'));
const ScrappingProcedurePage = lazy(() => import('../pages/services/scrapping-procedure/page'));
const ConsultationPage = lazy(() => import('../pages/services/consultation/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/services/used-car-purchase',
    element: <UsedCarPurchasePage />
  },
  {
    path: '/services/accident-car-purchase',
    element: <AccidentCarPurchasePage />
  },
  {
    path: '/services/car-export',
    element: <CarExportPage />
  },
  {
    path: '/services/truck-purchase',
    element: <TruckPurchasePage />
  },
  {
    path: '/services/scrapping-procedure',
    element: <ScrappingProcedurePage />
  },
  {
    path: '/services/consultation',
    element: <ConsultationPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
